import React, { useMemo } from 'react';
import { useTranslation } from 'hooks/useLingUI';
import { useRouter } from 'next/router';
import { isNotEmpty, isTruthy } from 'utility/functions';
import { isAllowed, isRequired, SeamlessHomeLinkProps } from 'features/dashboard/components/SeamlessHomeLink';
import Link from 'next/link';

import styles from './SeamlessHomeLink.module.scss';

export const SeamlessHomeLink = ({ url, style, className }: SeamlessHomeLinkProps) => {
  const { t } = useTranslation();
  const { asPath } = useRouter();

  const homeUrl = useMemo(() => {
    if (isNotEmpty(url)) return url;

    const [_, search] = asPath.split('?');
    const query = new URLSearchParams(search);

    return query.get('url_home');
  }, [url, asPath]);

  if (isAllowed && isRequired && isTruthy(homeUrl?.length)) {
    const txt = t('back-to-home');
    return (
      <Link
        scroll={true}
        href={`${homeUrl}`}
        target={'_top'}
        title={txt}
        style={style}
        className={className ?? styles.back}
      >
        {txt}
      </Link>
    );
  }

  return null;
};